import { HeatmapSurchargeCalendarFilters } from '~/types/heatmapSurcharge';

export const heatmapSurchargeQueryKeys = {
  all: ['lere', 'heatmap-surcharge'] as const,
  offers: (offerId?: string) => [...heatmapSurchargeQueryKeys.all, 'offers', offerId ?? ''] as const,
  calendars: () => [...heatmapSurchargeQueryKeys.all, 'calendar'] as const,
  calendar: (offerId: string, filters: HeatmapSurchargeCalendarFilters) =>
    [...heatmapSurchargeQueryKeys.calendars(), offerId, filters] as const,
  pdf: (offerId: string, generatedAt?: string) =>
    [...heatmapSurchargeQueryKeys.all, 'pdf', offerId, generatedAt] as const,
};
